import Vue from 'vue';
import Vuex from 'vuex';
import officialSupportStore from '../../resource/store/officialSupport';
Vue.use(Vuex);

export default new Vuex.Store(officialSupportStore);
